import { Link } from "react-router-dom";
import { PiPlusBold } from "react-icons/pi";
import routes from "@/routers/routes";
import { Button } from "rizzui";
import { orderData } from "@/data/order-data";
import PageHeader from "@/app/shared/page-header";
import ExportButton from "@/app/shared/export-button";
import { Order } from "@/types";

const pageHeader = {
    title: "All Orders",
    breadcrumb: [
        {
            href: routes.eCommerce.dashboard,
            name: "Dashboard",
        },
        {
            name: "Order List",
        },
    ],
};

interface HeaderProps {
    className?: string;
    orders: Order[];
}

export default function OrderPageHeader({ className, orders }: HeaderProps) {
    return (
        <PageHeader title={pageHeader.title} breadcrumb={pageHeader.breadcrumb}>
            <div className="mt-4 flex flex-col items-center gap-3 @sm:flex-row @lg:mt-0">
                <ExportButton
                    data={orders}
                    fileName="order_data"
                    header="ID,Tracking ID,Date,Sender,Receiver,Origin,Destination,Payment Method,Status"
                />
                <Link
                    to={routes.orders.createOrder}
                    className="w-full @lg:w-auto"
                >
                    <Button as="span" className="w-full @lg:w-auto">
                        <PiPlusBold className="me-1.5 h-[17px] w-[17px]" />
                        Request Order
                    </Button>
                </Link>
                <Link
                    to={routes.orders.createAgentOrder}
                    className="w-full @lg:w-auto"
                >
                    <Button
                        as="span"
                        className="w-full @lg:w-auto"
                        variant="outline"
                    >
                        <PiPlusBold className="me-1.5 h-[17px] w-[17px]" />
                        Request Shipment
                    </Button>
                </Link>
            </div>
        </PageHeader>
    );
}
